/* eslint-disable react-hooks/exhaustive-deps */

import React, { Suspense, useCallback, useContext, useState } from "react"
import { Paper } from "@material-ui/core"
import {
  ButtonAction,
  FormInputTagihan,
  getBayarByTagihanId,
  getDitanggungByTagihanId,
  getExternalByTagihanId,
  getKunjunganByTagihanId,
  getPenjualanByTagihanId,
  getTagihanById,
  getTotalSaldoByTagihanId,
  RESET_STATE_INPUT_TAGIHAN,
  getExportTagihanById,
  getExportTagihanByIdV2,
  getExportTagihanBillingObatKronis,
} from "./ui"
import { FormContext, FormProvider } from "./context/FormContext"
import { STYLE_PENJUALAN } from "../../Penjualan/InputPenjualan/ui"
import {
  defaultDateDisplay,
  defaultToastError,
  formatNumber,
  formatRupiah,
  getLocalName,
  isNull,
} from "App/utils/helpers"
import { prefixNoRM } from "../../Registrasi/utils"
import { RenderStatusPembelian } from "../../Penjualan/DaftarPenjualan/helpers"
import { LoadingBackdrop } from "components/atoms"
import { useSelector } from "react-redux"
import { getToken } from "App/utils/cookies"
import { KODE_PRINTER_SETTING, URL_SETTING } from "utils/all"
import ButtonFinalJasmed from "./ui/ButtonFinalJasmed"
import { BASE_URL_3 } from "App/constants"
import ModalUbahScale from "./ui/ModalUbahScale"
import ModalPreviewPDF from "./ui/ModalPreviewPDF"
import { ModalKwitansi } from "components/molecules"
import ModalPreviewBillingObatKronis from "./ui/ModalPreviewBillingObatKronis"

const TabMaster = React.lazy(() => import("./ui/TabMaster/TabMaster"))

export default function InputTagihan() {
  const classes = STYLE_PENJUALAN()

  return (
    <FormProvider>
      <RenderContent classes={classes} />
    </FormProvider>
  )
}

const RenderContent = ({ classes }) => {
  const { formData, setFormData, setDataPaket } = useContext(FormContext)
  const [rowsDitanggung, setRowsDitanggung] = useState([])
  const [rowsKunjungan, setRowsKunjungan] = useState([])
  const [rowsPenjualan, setRowsPenjualan] = useState([])
  const [rowsBayar, setRowsBayar] = useState([])
  const [rowsExternal, setRowsExternal] = useState([])

  const [loadingKunjungan, setLoadingKunjungan] = useState(false)
  const [loadingPenjualan, setLoadingPenjualan] = useState(false)
  const [loadingPrint, setLoadingPrint] = useState(false)
  const [loadingPrintv2, setLoadingPrintv2] = useState(false)
  const [loadingPrintBillingObatKronis, setLoadingPrintBillingObatKronis] =
    useState(false)
  const { setting } = useSelector((state) => state)
  const printerEnv = setting.printer_env
  const [scaleValue, setScaleValue] = useState(1)
  const [showModalScale, setShowModalScale] = useState(false)
  const [showModalViewPDF, setShowModalViewPDF] = useState(false)
  const [showModalViewBillingObatKronis, setShowModalViewBillingObatKronis] =
    useState(false)
  const [dataViewPDF, setDataViewPDF] = useState(null)
  const [dataViewBillingObatKronis, setDataViewBillingObatKronis] =
    useState(null)

  const [showModalKwitansi, setShowModalKwitansi] = useState(false)
  const [nilaiKwitansi, setNilaiKwitansi] = useState(0)

  const handleShowScale = () => {
    setScaleValue(1)
    setShowModalScale(true)
  }

  const handleChangeScale = (values) => {
    setScaleValue(values)
  }

  const setNewDataTabTagihan = async () => {
    if (!isNull(formData.tagihan_id)) {
      const res = await getTagihanById(formData.tagihan_id)
      const totalSaldo = await getTotalSaldoByTagihanId(formData.tagihan_id)
      if (res.state) {
        const tagihan = res.data.tagihan
        const pembayaran = res.data.pembayaran
        const ditanggung = res.data.ditanggung
        const totalPaket = res.data.totalPaket

        setFormData({
          ...formData,
          total_saldo: totalSaldo.data,
          tagihan: {
            jumlah: tagihan.jumlah,
            potongan: tagihan.potongan,
            tax: tagihan.tax,
            total_tagihan: tagihan.total_tagihan,
          },

          pembayaran: {
            total_tagihan: pembayaran.total_tagihan,
            total_pembayaran: pembayaran.total_pembayaran,
          },

          ditanggung: {
            ditanggung: ditanggung.ditanggung,
            total_tagihan: ditanggung.total_tagihan,
            jumlah_selisih: ditanggung.jumlah_selisih,
          },

          totalPaket: {
            total_tagihan: totalPaket.total_tagihan,
            total_paket: totalPaket.total_paket,
            jumlah_selisih: totalPaket.jumlah_selisih,
          },
        })
      }
    } else {
      setFormData({
        ...formData,
        tagihan: {
          jumlah: 0,
          potongan: 0,
          tax: 0,
          total_tagihan: 0,
        },

        pembayaran: {
          total_tagihan: 0,
          total_pembayaran: 0,
        },

        ditanggung: {
          ditanggung: 0,
          total_tagihan: 0,
          jumlah_selisih: 0,
        },

        totalPaket: {
          total_tagihan: 0,
          total_paket: 0,
          jumlah_selisih: 0,
        },
      })
    }
  }

  const setNewDataTabDitanggung = async () => {
    if (!isNull(formData.tagihan_id)) {
      const res = await getDitanggungByTagihanId(formData.tagihan_id)
      const totalSaldo = await getTotalSaldoByTagihanId(formData.tagihan_id)
      if (res.state) {
        setFormData({
          ...formData,
          total_saldo: totalSaldo.data,
          reload_final_jasmed: !formData.reload_final_jasmed,
        })
        setRowsDitanggung(res.data)
      } else {
        setRowsDitanggung([])
        defaultToastError(res.message)
      }
    }
  }

  const setNewDataTabKunjungan = async () => {
    if (!isNull(formData.tagihan_id)) {
      setLoadingKunjungan(true)
      const res = await getKunjunganByTagihanId(formData.tagihan_id)
      const totalSaldo = await getTotalSaldoByTagihanId(formData.tagihan_id)
      if (res.state) {
        setLoadingKunjungan(false)
        setFormData({
          ...formData,
          total_saldo: totalSaldo.data,
          reload_final_jasmed: !formData.reload_final_jasmed,
        })
        setRowsKunjungan(res.data)
      } else {
        setLoadingKunjungan(false)
        setRowsKunjungan([])
        defaultToastError(res.message)
      }
    }
  }

  const setNewDataTabPenjualan = async () => {
    if (!isNull(formData.tagihan_id)) {
      setLoadingPenjualan(true)
      const res = await getPenjualanByTagihanId(formData.tagihan_id)
      const totalSaldo = await getTotalSaldoByTagihanId(formData.tagihan_id)
      if (res.state) {
        setRowsPenjualan(res.data)
        setFormData({
          ...formData,
          total_saldo: totalSaldo.data,
          reload_final_jasmed: !formData.reload_final_jasmed,
        })
        setLoadingPenjualan(false)
      } else {
        setLoadingPenjualan(false)
        setRowsPenjualan([])
        defaultToastError(res.message)
      }
    }
  }

  const setNewDataTabBayar = async () => {
    if (!isNull(formData.tagihan_id)) {
      const res = await getBayarByTagihanId(formData.tagihan_id)
      const totalSaldo = await getTotalSaldoByTagihanId(formData.tagihan_id)

      if (res.state) {
        setRowsBayar(res.data)
        setFormData({
          ...formData,
          total_saldo: totalSaldo.data,
          reload_final_jasmed: !formData.reload_final_jasmed,
        })
      } else {
        setRowsBayar([])
        defaultToastError(res.message)
      }
    }
  }

  const setNewDataTabExternal = async () => {
    if (!isNull(formData.tagihan_id)) {
      const res = await getExternalByTagihanId(formData.tagihan_id)
      const totalSaldo = await getTotalSaldoByTagihanId(formData.tagihan_id)

      if (res.state) {
        setRowsExternal(res.data)
        setFormData({
          ...formData,
          total_saldo: totalSaldo.data,
          reload_final_jasmed: !formData.reload_final_jasmed,
        })
      } else {
        setRowsExternal([])
        defaultToastError(res.message)
      }
    }
  }

  const reset = () => {
    setFormData(RESET_STATE_INPUT_TAGIHAN)
    setRowsExternal([])
    setRowsBayar([])
    setRowsPenjualan([])
    setRowsDitanggung([])
    setRowsKunjungan([])
    setDataPaket([])
  }

  const handleClickPrint = (kop) => {
    return window.open(
      `http://localhost/${
        process.env.REACT_APP_PRINT_NAME
      }/public/api/print-rincian-tagihan?url=${BASE_URL_3}/tagihan/printByTagihanId/${
        formData.tagihan_id
      }&petugas=${getLocalName()}&kota_rumah_sakit=${
        printerEnv.kota_rumah_sakit
      }&token=${getToken()}&url_setting=${URL_SETTING}&kode_setting=${
        KODE_PRINTER_SETTING.printer_rincian_tagihan
      }&nama_rumah_sakit=${printerEnv.nama_rumah_sakit}&fax_rumah_sakit=${
        printerEnv.fax_rumah_sakit
      }&no_tlp_rumah_sakit=${
        printerEnv.no_tlp_rumah_sakit
      }&alamat_rumah_sakit=${printerEnv.alamat_rumah_sakit}&kop=${kop}`,
      "MsgWindow",
    )
  }

  const handleClickPrintKwitansi = (kop) => {
    return window.open(
      `http://localhost/${
        process.env.REACT_APP_PRINT_NAME
      }/public/api/print-kwitansi-penjualan?penjualan_id=${
        formData.tagihan_id
      }&tgl_penjualan=${defaultDateDisplay(
        formData.date,
        false,
      )}&rm_id=${prefixNoRM(formData.rm_id)}&nama=${
        formData.rm_name
      }&jml_bayar=${
        formData.pembayaran.total_pembayaran
      }&petugas=${getLocalName()}&penanggung=${
        formData.penanggung
      }&untuk_pembayaran=${formData.untuk_pembayaran}&kota_rumah_sakit=${
        printerEnv.kota_rumah_sakit
      }&token=${getToken()}&url_setting=${URL_SETTING}&kode_setting=${
        KODE_PRINTER_SETTING.printer_kwitansi_penjualan
      }&nama_rumah_sakit=${printerEnv.nama_rumah_sakit}&fax_rumah_sakit=${
        printerEnv.fax_rumah_sakit
      }&no_tlp_rumah_sakit=${
        printerEnv.no_tlp_rumah_sakit
      }&alamat_rumah_sakit=${printerEnv.alamat_rumah_sakit}&kop=${kop}`,
      "MsgWindow",
    )
  }

  const handleClickPrintPdf = async () => {
    setLoadingPrint(true)
    const response = await getExportTagihanById(formData.tagihan_id, scaleValue)
    if (response.state) {
      // fileDownload(response.data, `Tagihan ID ${formData.tagihan_id}.pdf`)
      const fileURL = URL.createObjectURL(response.data)
      setDataViewPDF(fileURL)
      setShowModalViewPDF(true)
      setLoadingPrint(false)
    } else {
      defaultToastError(response.message)
      setLoadingPrint(false)
    }
  }

  const handleClickPrintPdfV2 = async () => {
    setLoadingPrintv2(true)
    const response = await getExportTagihanByIdV2(
      formData.tagihan_id,
      scaleValue,
    )
    if (response.state) {
      // fileDownload(response.data, `Tagihan ID ${formData.tagihan_id}.pdf`)
      const fileURL = URL.createObjectURL(response.data)
      setDataViewPDF(fileURL)
      setShowModalViewPDF(true)
      setLoadingPrintv2(false)
    } else {
      defaultToastError(response.message)
      setLoadingPrintv2(false)
    }
  }

  const handleClickPrintBillingObatKronis = async () => {
    setLoadingPrintBillingObatKronis(true)
    const response = await getExportTagihanBillingObatKronis({
      id_tagihan: formData.tagihan_id,
    })
    if (response.state) {
      const fileURL = URL.createObjectURL(response.data)
      setDataViewBillingObatKronis(fileURL)
      setShowModalViewBillingObatKronis(true)
      setLoadingPrintBillingObatKronis(false)
    } else {
      defaultToastError(response.message)
      setLoadingPrintBillingObatKronis(false)
    }
  }

  const handleKeyPress = useCallback((event) => {
    if (event.key === "F6") {
      setFormData(RESET_STATE_INPUT_TAGIHAN)
    }
  }, [])

  React.useEffect(() => {
    document.addEventListener("keydown", handleKeyPress)
    return () => {
      document.removeEventListener("keydown", handleKeyPress)
    }
  }, [handleKeyPress])

  return (
    <Suspense fallback={<LoadingBackdrop />}>
      {showModalKwitansi && (
        <ModalKwitansi
          nama={formData.rm_name}
          noRM={formData.rm_id}
          nilai={formatRupiah(nilaiKwitansi)}
          // nilai={formatRupiah(formData.pembayaran.total_tagihan)}
          setShowModal={() => setShowModalKwitansi(false)}
          no_transaksi={formData.tagihan_id}
        />
      )}

      {showModalViewPDF && (
        <ModalPreviewPDF
          setShowModal={setShowModalViewPDF}
          dataPDF={dataViewPDF}
        />
      )}
      {showModalScale && (
        <ModalUbahScale
          setShowModal={setShowModalScale}
          scaleValue={scaleValue}
          handleChangeScale={handleChangeScale}
          handleClickPrintPdf={handleClickPrintPdf}
          handleClickPrintPdfV2={handleClickPrintPdfV2}
          loadingPrint={loadingPrint}
          loadingPrintv2={loadingPrintv2}
        />
      )}
      {showModalViewBillingObatKronis && (
        <ModalPreviewBillingObatKronis
          setShowModal={setShowModalViewBillingObatKronis}
          dataPDF={dataViewBillingObatKronis}
        />
      )}
      <div className={classes.root}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "1rem 0",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <p
              style={{
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              INPUT TAGIHAN
            </p>
            <div>
              <ButtonFinalJasmed
                formData={formData}
                setFormData={setFormData}
              />
            </div>
          </div>

          <div
            style={{
              display: "flex",
              gap: "1rem",
            }}
          >
            <RenderStatusPembelian status={formData.status_tagihan} />
            <p>Saldo pada tagihan ini : {formatNumber(formData.total_saldo)}</p>
          </div>
        </div>
        <FormInputTagihan
          classes={classes}
          reloadTagihan={setNewDataTabTagihan}
          rowsKunjungan={rowsKunjungan}
          setRowsKunjungan={setRowsKunjungan}
        />
        <div
          style={{
            marginTop: "1rem",
          }}
        >
          <Paper
            className={classes.paper}
            style={{
              padding: "1rem",
              margin: "1rem 0",
            }}
          >
            <TabMaster
              rowsDitanggung={rowsDitanggung}
              setRowsDitanggung={setRowsDitanggung}
              setNewDataTabDitanggung={setNewDataTabDitanggung}
              rowsKunjungan={rowsKunjungan}
              loadingKunjungan={loadingKunjungan}
              setNewDataTabKunjungan={setNewDataTabKunjungan}
              rowsPenjualan={rowsPenjualan}
              loadingPenjualan={loadingPenjualan}
              setNewDataTabPenjualan={setNewDataTabPenjualan}
              rowsBayar={rowsBayar}
              setNewDataTabBayar={setNewDataTabBayar}
              setNewDataTabTagihan={setNewDataTabTagihan}
              rowsExternal={rowsExternal}
              setNewDataTabExternal={setNewDataTabExternal}
              setShowModalKwitansi={setShowModalKwitansi}
              setNilaiKwitansi={setNilaiKwitansi}
            />
          </Paper>
          <ButtonAction
            showModalKwitansi={showModalKwitansi}
            setShowModalKwitansi={setShowModalKwitansi}
            nilaiKwitansi={nilaiKwitansi}
            setNilaiKwitansi={setNilaiKwitansi}
            reset={reset}
            setNewDataTabTagihan={setNewDataTabTagihan}
            handleClickPrint={handleClickPrint}
            handleClickPrintKwitansi={handleClickPrintKwitansi}
            handleClickPrintPdf={handleClickPrintPdf}
            handleClickPrintPdfV2={handleClickPrintPdfV2}
            handleClickPrintBillingObatKronis={
              handleClickPrintBillingObatKronis
            }
            loadingPrintBillingObatKronis={loadingPrintBillingObatKronis}
            loadingPrint={loadingPrint}
            loadingPrintv2={loadingPrintv2}
            tagihanID={formData.tagihan_id}
            formData={formData}
            handleShowScale={handleShowScale}
          />
        </div>

        <ul
          style={{
            fontSize: "11px",
            marginTop: "2rem",
            padding: "1rem",
          }}
        >
          <li>Gunakan F2 untuk memunculkan modal cari kunjungan</li>
          <li>Gunakan F6 untuk untuk reset form</li>
        </ul>
      </div>
    </Suspense>
  )
}
